<template><div><h1 id="extra-publikation-erfassen" tabindex="-1"><a class="header-anchor" href="#extra-publikation-erfassen"><span>Extra-Publikation erfassen</span></a></h1>
<p>Extra-Publikation erfassen — Erfassen von Extra-Publikationen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Das Erfassen von Extra-Publikationen kann mittels diesem Program als Sammelbearbeitung durchgeführt werden. Die einzulesenden Daten können in bestimmten Formaten vorliegen:</p>
<ol>
<li>
<p>Dateiformat E-Mail: in jeder Zeile eine vollständige E-Mail Adresse. Beispiel:</p>
<p>muster@firma.ch
huber_daniela@bluewin.ch
roger.meier@gmx.net
info@business.ch
susi@yahoo.com</p>
</li>
<li>
<p>Dateiformat Personen-ID: in jeder Zeile eine vollständige Personen-ID. Beispiel:</p>
<p>214311
6878
453
89567
2534</p>
</li>
</ol>
<p>Es wird empfohlen, zuerst einen Testlauf durchzuführen, bevor die Extra-Publikationen definitiv eingelesen werden. Siehe Outputbeispiel Protokolldatei.</p>
<p>Lesebeispiel (unten): Liest die Daten aus der Datei &quot;testeinlesen&quot; und führt einen Testlauf durch. Die Adressen werden nur geprüft, noch nicht eingelesen.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Adressverwaltung → Sammelbearbeitung, Produktion → Extra-Publikation erfassen</p>
<p>+------------------- Extra-Publikation erfassen --------------------+
| Input-Datei.................: /z/testeinlesen                     |
| Input Format................:              [V]                    |
| Bearbeitung (Test/Definitiv): Test                                |
| Extra Publikation erfassen..:                                     |
| Bevorzugter Kanal...........:                                     |
| Anzahl......................: 1                                   |
|                                                                   |
+-------------------------------------------------------------------+</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Input-Datei</dt>
<dd>Dateiname und Pfad der Datei, die eingelesen werden soll.</dd>
<dt>Input Format</dt>
<dd>Folgende Input Formate sind unterstützt: E-Mail, Personen-ID.</dd>
<dt>Bearbeitung (Test/Definitiv)</dt>
<dd>Test = Testlauf; die Daten werden nicht eingelesen, das Protokoll gibt Auskunft über die einzulesenden Daten. Definitiv = Einlesen der Daten.</dd>
<dt>Extra Publikation erfassen</dt>
<dd>Jede Adresse wird mit dieser Extra-Publikation versehen und dieser muss einem im System vorhandenen Extra-Publikation entsprechen.</dd>
<dt>Bevorzugter Kanal</dt>
<dd>Auswahl des bevorzugten Kanals für die Extra-Publikation.</dd>
<dt>Anzahl</dt>
<dd>Anzahl Publikationen</dd>
<dt>Ausgabe</dt>
<dd>Standard</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Beispiel einer Protokolldatei:</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                          30.07.2002 10:16:01 ers  Seite     1</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                          Extra-Publikation erfassen</span>
<span class="line">      Input-Datei.................: /z/testeinlesen</span>
<span class="line">      Input Format................: Personen-ID</span>
<span class="line">      Bearbeitung (Test/Definitiv): Test</span>
<span class="line">      Extra Publikation erfassen..: + abc</span>
<span class="line">      Bevorzugter Kanal...........: E-Mail</span>
<span class="line">      Anzahl......................: 1</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">Fehler in Zeile11 5678dfr</span>
<span class="line">Fehler in Zeile12 56$dl34</span>
<span class="line"></span>
<span class="line">Zeilen zum Einlesen:        12</span>
<span class="line">davon eingelesen...:        10</span>
<span class="line">davon fehlerhaft...:         2</span>
<span class="line">sonstige Fehler....:         0</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: 2 Zeilen können nicht eingelesen werden. In der Auflistung ist ersichtlich, dass diese nicht vollständig in korrektem Format vorhanden sind.</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Externe Daten (aus Input-Datei).</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Es werden Extra-Publikationen in den Adressen erfasst.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


